var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "general" },
    [
      !_vm.isCorpUser
        ? [
            _c("div", { staticClass: "sp" }, [
              _c(
                "h1",
                { staticClass: "com-title com-ht" },
                [
                  _c("span", [
                    _c("i"),
                    _vm._v(_vm._s(_vm.isShowApiList ? "我的模板" : "企业模板"))
                  ]),
                  _vm._v(" \n          "),
                  _c(
                    "el-tooltip",
                    { attrs: { effect: "dark", placement: "bottom-end" } },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c(
                            "p",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [
                              _c("img", {
                                staticStyle: {
                                  "max-width": "18px",
                                  "margin-right": "10px"
                                },
                                attrs: {
                                  src: "/images/advancedVersion/pdf_1.png",
                                  alt: ""
                                }
                              }),
                              _c("span", [
                                _vm._v(
                                  "变量模板:创建时可以添加变量，发起时填写变量信息"
                                )
                              ])
                            ]
                          ),
                          _c("p", [
                            _c("img", {
                              staticStyle: {
                                "max-width": "18px",
                                "margin-right": "10px"
                              },
                              attrs: {
                                src: "/images/advancedVersion/file_1.png",
                                alt: ""
                              }
                            }),
                            _c("span", [
                              _vm._v(
                                "仅上传文件:创建时无需添加变量，发起时可在线编辑文件内容"
                              )
                            ])
                          ])
                        ]
                      ),
                      _c("span", { staticClass: "el-icon-question" })
                    ]
                  ),
                  !_vm.isInDingTalk
                    ? _c("span", { staticClass: "to-temp-sty" }, [
                        _vm._v("海量合同模板供您参考  "),
                        _c(
                          "a",
                          {
                            staticStyle: { color: "#ec1c1c" },
                            attrs: {
                              href:
                                _vm.GlobalConfig.domain.junziqanIndex +
                                "/contract_template.html",
                              target: "_blank"
                            }
                          },
                          [_vm._v("立即前往>>")]
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "search" },
                [
                  _c("el-input", {
                    staticStyle: { "margin-right": "10px" },
                    attrs: {
                      placeholder: "请输入模板名称",
                      size: "small",
                      clearable: ""
                    },
                    model: {
                      value: _vm.templateName,
                      callback: function($$v) {
                        _vm.templateName = $$v
                      },
                      expression: "templateName"
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.serchTemplate(_vm.templateName, 1)
                        }
                      }
                    },
                    [_vm._v("查询\n          ")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.reset } },
                    [_vm._v("重置")]
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "box-wrap" },
              [
                _vm._l(_vm.dataList, function(item, index) {
                  return _c("div", { key: index, staticClass: "temone" }, [
                    _c("div", { staticClass: "t-box" }, [
                      _vm.beWord(item.tplName)
                        ? _c("img", {
                            staticClass: "y-img",
                            attrs: { src: "/images/advancedVersion/file_1.png" }
                          })
                        : _c("img", {
                            staticClass: "y-img",
                            attrs: { src: "/images/advancedVersion/pdf_1.png" }
                          }),
                      _c("p", [_vm._v(_vm._s(item.tplName))]),
                      _c("div", { staticClass: "msk" }, [
                        _c(
                          "div",
                          {
                            staticClass: "list_one left-linear",
                            staticStyle: { "border-bottom": "1px solid" }
                          },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "light",
                                  content: "修改",
                                  placement: "left"
                                }
                              },
                              [
                                _c("span", {
                                  staticClass:
                                    "el-icon-edit-outline setting_icon",
                                  staticStyle: { "margin-top": "1px" },
                                  attrs: { title: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.modulesEditFn(item)
                                    }
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "list_one top-linear",
                            staticStyle: { "border-left": "1px solid" }
                          },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "light",
                                  content: "删除",
                                  placement: "right"
                                }
                              },
                              [
                                _c("span", {
                                  staticClass: "el-icon-delete setting_icon",
                                  attrs: { title: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.delTpl(item)
                                    }
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "list_one bottom-linear",
                            staticStyle: { "border-right": "1px solid" }
                          },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "light",
                                  content: "该模板允许授权给成员",
                                  placement: "left"
                                }
                              },
                              [
                                _c("switch-button", {
                                  attrs: { object: item },
                                  on: { confirmFn: _vm.seccondConfirmFn },
                                  model: {
                                    value: item.allowMemberUse,
                                    callback: function($$v) {
                                      _vm.$set(item, "allowMemberUse", $$v)
                                    },
                                    expression: "item.allowMemberUse"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        item.tplType !== 4
                          ? _c(
                              "div",
                              {
                                staticClass: "list_one right-linear",
                                staticStyle: { "border-top": "1px solid" }
                              },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "light",
                                      content: "查看",
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "el-icon-view setting_icon",
                                      staticStyle: { "margin-top": "1px" },
                                      attrs: { title: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.viewDetailFn(item)
                                        }
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ]),
                    item.allowMemberUse
                      ? _c("div", { staticClass: "template_auth" }, [
                          _c(
                            "div",
                            {
                              class: [
                                "auth_btn",
                                {
                                  not_active:
                                    !_vm.authTemIdList.includes(item.tplId) ||
                                    !item.allowMemberUse
                                }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.emitAuthListFn(item)
                                }
                              }
                            },
                            [_vm._v("模板授权")]
                          )
                        ])
                      : _c("div", { staticClass: "no_template_auth" }, [
                          _c("span", [_vm._v("授权成员使用已关闭")])
                        ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isManCorp,
                            expression: "isManCorp"
                          }
                        ],
                        class: _vm.isManCorp ? "a-btns-sty" : ""
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "a-btn",
                            on: {
                              click: function($event) {
                                return _vm.templateUseFn(item)
                              }
                            }
                          },
                          [_vm._v("立即使用")]
                        ),
                        _vm.isAdVn(item) && !item.signerFixed
                          ? _c(
                              "div",
                              {
                                staticClass: "a-btn",
                                on: {
                                  click: function($event) {
                                    return _vm.batchInit(item)
                                  }
                                }
                              },
                              [_vm._v("\n              批量发起\n            ")]
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                }),
                _c("div", { staticClass: "temone add" }, [
                  _c("div", { staticStyle: { padding: "20px" } }, [
                    _c("span", [_vm._v("选择创建方式")]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "margin-top": "5px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "add_button_style",
                            on: {
                              click: function($event) {
                                return _vm.templateAddChoose(1)
                              }
                            }
                          },
                          [_vm._v("\n                PDF模板\n              ")]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "align-items": "center"
                            }
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                attrs: {
                                  action: "#",
                                  accept: ".doc,.docx",
                                  "before-upload": _vm.fileOnBeforeUpload,
                                  "show-file-list": false,
                                  "file-list": _vm.fileList,
                                  "on-error": _vm.fileOnError
                                }
                              },
                              [
                                _c("div", { staticClass: "add_button_style" }, [
                                  _vm._v("仅上传文件")
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "add_button_style",
                            on: {
                              click: function($event) {
                                return _vm.templateAddChoose(0)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                自定义模板创建\n              "
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ],
              2
            )
          ]
        : _vm._e(),
      _vm.isShowApiList
        ? [
            !_vm.isInDingTalk
              ? [
                  _c(
                    "h1",
                    { staticClass: "com-title com-ht" },
                    [
                      _c("i"),
                      _vm._v("API模板"),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "primary", size: "mini" },
                          on: {
                            click: function($event) {
                              _vm.importVisible = true
                            }
                          }
                        },
                        [_vm._v("导入")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "box-wrap" },
                    [
                      _vm._l(_vm.apiTemplateList, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "temone temone-center" },
                          [
                            _c("div", { staticClass: "t-box" }, [
                              _c("img", {
                                staticClass: "y-img",
                                attrs: {
                                  src:
                                    item.tplVersion === 2
                                      ? "/images/advancedVersion/pdf_1.png"
                                      : "/images/advancedVersion/file_html.png"
                                }
                              }),
                              _c("p", [_vm._v(_vm._s(item.tplName))]),
                              _c("div", { staticClass: "msk" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "list_one top-linear",
                                    staticStyle: { "border-right": "1px solid" }
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "el-icon-edit-outline",
                                      staticStyle: { "margin-top": "1px" },
                                      attrs: { title: "修改" },
                                      on: {
                                        click: function($event) {
                                          return _vm.APITempEdit(item)
                                        }
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "list_one right-linear",
                                    staticStyle: {
                                      "border-bottom": "1px solid"
                                    }
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "el-icon-delete",
                                      attrs: { title: "删除" },
                                      on: {
                                        click: function($event) {
                                          return _vm.delApiTpl(item)
                                        }
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "list_one left-linear",
                                    staticStyle: { "border-top": "1px solid" }
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "el-icon-folder",
                                      attrs: { title: "导出" },
                                      on: {
                                        click: function($event) {
                                          return _vm.exportTemplateFn(item)
                                        }
                                      }
                                    })
                                  ]
                                )
                              ])
                            ]),
                            _c("div", { staticClass: "tpid" }, [
                              _c("div", { staticClass: "row-sty" }, [
                                _vm._v("ID:" + _vm._s(item.serialNum))
                              ]),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.tplVersion !== 2,
                                      expression: "item.tplVersion !== 2"
                                    }
                                  ],
                                  staticClass: "row-sty"
                                },
                                [_vm._v("模板编码:" + _vm._s(item.tplCode))]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.shareCode,
                                      expression: "item.shareCode"
                                    }
                                  ],
                                  staticClass: "row-sty",
                                  attrs: { title: item.shareCode }
                                },
                                [
                                  _vm._v(
                                    "\n                共享编码:" +
                                      _vm._s(item.shareCode) +
                                      "\n              "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      }),
                      _c("div", { ref: "apiTempAddRef" }, [
                        _c("div", { staticClass: "temone add" }, [
                          _c("div", { staticStyle: { padding: "20px" } }, [
                            _c("p", [_vm._v("选择创建方式")]),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "text-align": "center",
                                  "margin-top": "10px"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "space-between",
                                      "align-items": "center"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "add_button_style",
                                        on: { click: _vm.templateAddAPI }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      PDF模板\n                      "
                                        ),
                                        _c("img", {
                                          staticClass: "new-icon",
                                          attrs: {
                                            src: "/images/icon/new.png",
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "space-between",
                                      "align-items": "center"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "add_button_style",
                                        on: { click: _vm.APIAdd }
                                      },
                                      [_vm._v("自定义模板创建")]
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    ],
                    2
                  )
                ]
              : _vm._e()
          ]
        : _vm._e(),
      _c("goto-auth", {
        attrs: { authDialog: _vm.authDialog },
        on: {
          "update:authDialog": function($event) {
            _vm.authDialog = $event
          },
          "update:auth-dialog": function($event) {
            _vm.authDialog = $event
          }
        }
      }),
      _vm.plDialogVisible
        ? _c("batch-launch", {
            attrs: { show: _vm.plDialogVisible, tplId: _vm.batchTplId },
            on: {
              "update:show": function($event) {
                _vm.plDialogVisible = $event
              }
            }
          })
        : _vm._e(),
      _c("editor-pup", {
        attrs: { showofficeEditor: _vm.showofficeEditor, editor: _vm.editor },
        on: {
          "update:showofficeEditor": function($event) {
            _vm.showofficeEditor = $event
          },
          "update:showoffice-editor": function($event) {
            _vm.showofficeEditor = $event
          },
          saveLoading: _vm.saveLoading
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "模板授权",
            visible: _vm.TempAuth.visi,
            width: "60%"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.TempAuth, "visi", $event)
            }
          }
        },
        [_c("TempGrant", { attrs: { tempInfo: _vm.TempAuth.tempInfo } })],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "模板导入",
            visible: _vm.importVisible,
            width: "30%",
            "before-close": function() {
              return (_vm.importVisible = false)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "imTemplateRef",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.imTemplateForm,
                rules: _vm.imTemplateRules,
                "label-width": "120px"
              }
            },
            [
              _c("el-form-item", { attrs: { label: "上传模板文件：" } }, [
                _vm.imTemplateFile
                  ? _c("div", { staticClass: "im_template_avatar" }, [
                      _vm.imTemplateForm.tplType === 2
                        ? _c("img", {
                            staticClass: "avatar",
                            attrs: {
                              src: "/images/advancedVersion/file_html.png"
                            }
                          })
                        : _c("img", {
                            staticClass: "avatar",
                            attrs: { src: "/images/advancedVersion/pdf_1.png" }
                          }),
                      _c("div", { staticClass: "im_tem_delete" }, [
                        _c("i", {
                          staticClass: "el-icon-delete",
                          staticStyle: {
                            "font-size": "25px",
                            cursor: "pointer"
                          },
                          on: { click: _vm.deleteImTemplateFn }
                        })
                      ])
                    ])
                  : _c(
                      "div",
                      { staticClass: "im_template_upload" },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "avatar-uploader",
                            attrs: {
                              action: "#",
                              accept: "*",
                              "show-file-list": false,
                              "before-upload": _vm.beforeImTemplateUpload
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-plus avatar-uploader-icon"
                            })
                          ]
                        )
                      ],
                      1
                    )
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "模板名称：", prop: "tplName" } },
                [
                  _c("el-input", {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.imTemplateForm.tplName,
                      callback: function($$v) {
                        _vm.$set(_vm.imTemplateForm, "tplName", $$v)
                      },
                      expression: "imTemplateForm.tplName"
                    }
                  })
                ],
                1
              ),
              _vm.imTemplateForm.tplType === 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "模板id：", prop: "tplId" } },
                    [
                      _c("el-input", {
                        attrs: { size: "small" },
                        model: {
                          value: _vm.imTemplateForm.tplId,
                          callback: function($$v) {
                            _vm.$set(_vm.imTemplateForm, "tplId", $$v)
                          },
                          expression: "imTemplateForm.tplId"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { staticStyle: { "text-align": "right" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        loading: _vm.importFileLoading
                      },
                      on: {
                        click: function($event) {
                          return _vm.importTemplateSubmit("ruleForm")
                        }
                      }
                    },
                    [_vm._v("导入")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fd1576b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fd1576b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/console/template/tempManage.vue
// module id = AfzL
// module chunks = 0 7 12 13 14 17 26 28 32 34 52